import { initBackForward, isBackForward } from '@/libs/util/windowEventHelper';
import { noop } from '@fxts/core';
import * as Sentry from '@sentry/browser';
import { Application } from './application';

const main = async () => {
  const app = new Application();

  app.getInitialData().setRequesterAxios().setAppListener().initLazyLoad().checkImageFormat().setSentryConfig();

  await app
    .hydrate()
    .then((app) => app.setMauth())
    .then((app) => app.initChannelTalk());

  app.openPopup();

  if (isBackForward()) app.closeModal();
  initBackForward(app.closeModal.bind(app));

  window.MauthApp = app;
};

await main().then(noop).catch(Sentry.captureException);
